import { Div } from '@codesuma/baseline'
import style from './index.module.css'

// One physical slide of the 3-slide window. `pos` is the physical position:
// 0 = left, 1 = center (visible), 2 = right.
export const Slide = (initialPos: number) => {
    let pos = initialPos

    const base = Div()
    base.addClass(style.slide)
    place()

    function place() {
        // The container is 300% wide, so each physical position is a third of it.
        base.style({ left: (pos * 100) / 3 + '%' })
    }

    return Object.assign(base, {
        // Shift with the committed swipe (dir = +1 when everything moved right),
        // wrapping around so the window always covers left/center/right.
        recycle(dir: number) {
            pos = (pos + dir + 3) % 3
            place()
        },
        getPos() {
            return pos
        },
    })
}

export type ISlide = ReturnType<typeof Slide>
